'use strict';

module.exports = require('string.prototype.trimleft');



//////////////////
// WEBPACK FOOTER
// ./node_modules/es7-shim/String.prototype.trimLeft.js
// module id = 812
// module chunks = 0